<template>
  <div class="div">
    <div class="w100" v-if="activeName === '1'">
      <div class="dom-card" v-loading="DeviceValueLoading">
        <div class="dom-card-title df jub">
          <span>设备价值分布情况</span>
          <div>
            <el-select
              v-model="DeviceValueType"
              placeholder="请选择"
              style="width: 250px"
            >
              <el-option label="按楼栋分布" value="bui"> </el-option>
              <el-option label="按专业设备分布" value="dev"> </el-option>
            </el-select>
            <span class="hint-text">单位：（台） </span>
          </div>
        </div>
        <div class="w100 df">
          <div style="width: 70%">
            <EchartsDom
              type="bar2"
              :data="DeviceValue?.blist || []"
              width="100%"
              yAxisName="台数"
              :isStack="false"
              :grid="{
                left: 60,
                top: 60,
                right: 40,
                bottom: 30,
              }"
              legendTop="10px"
              height="220px"
              v-if="DeviceValueType === 'bui'"
            >
            </EchartsDom>
            <EchartsDom
              type="bar2"
              :data="DeviceValue?.dlist || []"
              width="100%"
              yAxisName="台数"
              :isStack="false"
              :grid="{
                left: 60,
                top: 60,
                right: 40,
                bottom: 30,
              }"
              legendTop="10px"
              height="220px"
              v-if="DeviceValueType === 'dev'"
            >
            </EchartsDom>
          </div>
          <el-divider direction="vertical" class="divider"></el-divider>
          <div style="width: 30%">
            <EchartsDom
              type="pie"
              :data="DeviceValue.bpiechartList || []"
              width="100%"
              legendTop="10px"
              height="220px"
              legendPosition="left"
              v-if="DeviceValueType === 'bui'"
            >
            </EchartsDom>
            <EchartsDom
              type="pie"
              :data="DeviceValue.tpiechartList || []"
              width="100%"
              legendTop="10px"
              height="220px"
              legendPosition="left"
              v-if="DeviceValueType === 'dev'"
            >
            </EchartsDom>
          </div>
        </div>
      </div>

      <div class="dom-card" style="margin-top: 10px" v-loading="DeviceLifespanLoading">
        <div class="dom-card-title df aic jub">
          <span>设备寿命分布情况</span>
          <div>
            <el-select
              v-model="DeviceLifespanType"
              placeholder="请选择"
              style="width: 250px"
            >
              <el-option label="按楼栋分布" value="bui"> </el-option>
              <el-option label="按专业设备分布" value="dev"> </el-option>
            </el-select>
            <span class="hint-text">单位：（台） </span>
          </div>
        </div>
        <div class="df w100" style="gap: 10px">
          <div style="width: 70%">
            <EchartsDom
              type="bar2"
              :data="DeviceLifespan?.blist || []"
              width="100%"
              yAxisName="台数"
              :grid="{
                left: 60,
                top: 60,
                right: 40,
                bottom: 30,
              }"
              legendTop="10px"
              height="220px"
              :isStack="false"
              v-if="DeviceLifespanType === 'bui'"
            >
            </EchartsDom>
            <EchartsDom
              type="bar2"
              v-if="DeviceLifespanType === 'dev'"
              :data="DeviceLifespan?.dlist || []"
              width="100%"
              yAxisName="台数"
              :grid="{
                left: 60,
                top: 60,
                right: 40,
                bottom: 30,
              }"
              legendTop="10px"
              height="220px"
              :isStack="false"
            >
            </EchartsDom>
          </div>
          <el-divider direction="vertical" class="divider"></el-divider>
          <div style="width: 30%">
            <EchartsDom
              type="pie"
              :data="DeviceLifespan.bpiechartList || []"
              width="100%"
              legendTop="10px"
              height="220px"
              legendPosition="left"
            >
            </EchartsDom>
          </div>
        </div>
      </div>
      <div
        class="dom-card"
        style="margin-top: 10px"
        v-loading="DeviceDistributionLoading"
      >
        <div class="dom-card-title df aic jub">
          <span>设备区域情况</span>
          <span class="hint-text">单位：（台） </span>
        </div>
        <div class="df w100">
          <div style="width: 70%">
            <EchartsDom
              type="bar2"
              :data="DeviceDistribution.blist || []"
              width="100%"
              yAxisName="台数"
              :grid="{
                left: 60,
                top: 60,
                right: 40,
                bottom: 30,
              }"
              legendTop="10px"
              height="220px"
              :isStack="false"
            >
            </EchartsDom>
          </div>
          <el-divider direction="vertical" class="divider"></el-divider>
          <div style="width: 30%">
            <EchartsDom
              type="pie"
              :data="DeviceDistribution.bpiechartList || []"
              width="100%"
              legendTop="10px"
              height="220px"
              legendPosition="left"
            >
            </EchartsDom>
          </div>
        </div>
      </div>
      <div class="dom-card" style="margin-top: 10px" v-loading="DeviceScrappingLoading">
        <div class="dom-card-title df jub">
          <span>设备报废情况</span>
          <span class="hint-text">单位：（台） </span>
        </div>
        <div class="df w100" style="gap: 10px">
          <EchartsDom
            type="pie"
            :data="DeviceScrapping?.blist || []"
            width="50%"
            :title="{
              text: '按楼栋分布',
              top: '5px',
              left: 'center',
            }"
            legendPosition="left"
            legendLeft="15%"
            height="240px"
            pieRadius="50%"
          >
          </EchartsDom>
          <el-divider direction="vertical" class="divider"></el-divider>
          <EchartsDom
            type="pie"
            :data="DeviceScrapping?.dlist || []"
            width="50%"
            title="按专业设备分布"
            legendPosition="left"
            legendLeft="15%"
            height="240px"
            pieRadius="50%"
          >
          </EchartsDom>
        </div>
      </div>
    </div>

    <div style="height: 20px"></div>
  </div>
</template>
<script>
import moment from "moment";

import EchartsDom from "@/components/EchartsDom/EchartsDom.vue";
export default {
  data() {
    return {
      activeName: "1",
      searchData: {
        SortType: "Building",
        TimeType: "YearMonth",

        StartTime: "",
        EndTime: "",
        DeviceTypes: [],
        Buildings: [],
        searchYear: [],
        StartTimeYear: "",
        EndTimeYear: "",
      },
      loading: false,
      deviceTypeLoading: false,
      buildingLoading: false,
      debouncedGetDataList: null,
      BuildingsList: [],
      DeviceTypesList: [],
      workOrderList: {},
      workOrderTimeList: [],
      workOrderTimeList2: [],
      workOrderAreaList: [],
      workOrderDeviceList: [],

      spanArr: [], // 用于存储 blist 合并行信息
      spanArrTlist: [], // 用于存储 tlist 合并行信息

      DeviceDistributionLoading: false,
      DeviceDistribution: [],
      DeviceScrappingType: "bui",
      DeviceScrappingLoading: false,
      DeviceScrapping: {},
      DeviceValue: {},
      DeviceValueType: "bui",
      DeviceValueLoading: false,
      DeviceLifespan: {},
      DeviceLifespanType: "bui",
      DeviceLifespanLoading: false,
      //有参数条件的
      DeviceFault: [],
      DeviceFaultLoading: false,
      DeviceStopPower: [],
      DeviceStopPowerLoading: false,
      DeviceStopPowerHourType: {},
      DeviceStopPowerHourTypeLoading: false,
      DeviceStopPowerHourTypeSelect: "bui",
      DeviceStopPowerCountType: {},
      DeviceStopPowerCountTypeSelect: "bui",
      DeviceStopPowerCountTypeLoading: false,
      DeviceFaultYearMonth: {},
      DeviceFaultYearMonthSelect: "bui",
      DeviceFaultYearMonthLoading: false,
      DeviceFaultYears: {},
      DeviceFaultYearsSelect: "bui",
      DeviceFaultYearsLoading: false,
      DeviceFaultType: {},
      DeviceFaultTypeSelect: "bui",
      DeviceFaultTypeLoading: false,
      DeviceFaultTypeYear: [],
      DeviceFaultTypeYearLoading: false,
    };
  },
  props: {},
  components: { EchartsDom },
  methods: {
    // 各区设备故障情况---故障次数
    async getDeviceFault() {
      this.DeviceFaultLoading = true;
      this.$http
        .post("/PB/PB_Project/GetDeviceFaultAnalysis", {
          TimeType: this.searchData.TimeType,
          StartTime: this.searchData.StartTime,
          EndTime: this.searchData.EndTime,
          DeviceTypes: this.searchData.DeviceTypes.join(","),
          Buildings: this.searchData.Buildings.join(","),
        })
        .then((res) => {
          this.DeviceFaultLoading = false;
          if (res.Success) {
            this.DeviceFault = res.Data || [];
          } else {
            this.$notify.error(res.Msg);
          }
        });
    },
    //各区设备故障情况---停机分布
    async getDeviceStopPower() {
      this.DeviceStopPowerLoading = true;
      this.$http
        .post("/PB/PB_Project/GetDeviceStopPowerAnalysis", {
          TimeType: this.searchData.TimeType,
          StartTime: this.searchData.StartTime,
          EndTime: this.searchData.EndTime,
          DeviceTypes: this.searchData.DeviceTypes.join(","),
          Buildings: this.searchData.Buildings.join(","),
        })
        .then((res) => {
          this.DeviceStopPowerLoading = false;
          if (res.Success) {
            this.DeviceStopPower = res.Data || [];
          } else {
            this.$notify.error(res.Msg);
          }
        });
    },
    //各区设备各月停机统计-按楼和按分类 统计-时长统计
    async getDeviceStopPowerHourType() {
      this.DeviceStopPowerHourTypeLoading = true;
      this.$http
        .post("/PB/PB_Project/GetDeviceStopPowerHourTypeAnalysis", {
          TimeType: this.searchData.TimeType,
          StartTime: this.searchData.StartTime,
          EndTime: this.searchData.EndTime,
          DeviceTypes: this.searchData.DeviceTypes.join(","),
          Buildings: this.searchData.Buildings.join(","),
        })
        .then((res) => {
          this.DeviceStopPowerHourTypeLoading = false;
          if (res.Success) {
            this.DeviceStopPowerHourType = res.Data || {};
          } else {
            this.$notify.error(res.Msg);
          }
        });
    },
    //各区设备各月停机统计-按楼和按分类 统计-次数统计
    async getDeviceStopPowerCountType() {
      this.DeviceStopPowerCountTypeLoading = true;
      this.$http
        .post("/PB/PB_Project/GetDeviceStopPowerCountTypeAnalysis", {
          TimeType: this.searchData.TimeType,
          StartTime: this.searchData.StartTime,
          EndTime: this.searchData.EndTime,
          DeviceTypes: this.searchData.DeviceTypes.join(","),
          Buildings: this.searchData.Buildings.join(","),
        })
        .then((res) => {
          this.DeviceStopPowerCountTypeLoading = false;
          if (res.Success) {
            this.DeviceStopPowerCountType = res.Data || {};
          } else {
            this.$notify.error(res.Msg);
          }
        });
    },
    //设备故障分析-故障频次 按楼 按分类
    async getDeviceFaultYearMonth() {
      this.DeviceFaultYearMonthLoading = true;
      this.$http
        .post("/PB/PB_Project/GetDeviceFaultYearMonthAnalysis", {
          TimeType: this.searchData.TimeType,
          StartTime: this.searchData.StartTime,
          EndTime: this.searchData.EndTime,
          DeviceTypes: this.searchData.DeviceTypes.join(","),
          Buildings: this.searchData.Buildings.join(","),
        })
        .then((res) => {
          this.DeviceFaultYearMonthLoading = false;
          if (res.Success) {
            this.DeviceFaultYearMonth = res.Data || {};
          } else {
            this.$notify.error(res.Msg);
          }
        });
    },
    //设备全周期故障分布
    async getDeviceFaultYears() {
      this.DeviceFaultYearsLoading = true;
      this.$http
        .post("/PB/PB_Project/GetDeviceFaultYearsAnalysis", {
          TimeType: this.searchData.TimeType,
          StartTime: this.searchData.StartTime,
          EndTime: this.searchData.EndTime,
          DeviceTypes: this.searchData.DeviceTypes.join(","),
          Buildings: this.searchData.Buildings.join(","),
        })
        .then((res) => {
          this.DeviceFaultYearsLoading = false;
          if (res.Success) {
            this.DeviceFaultYears = res.Data || {};
          } else {
            this.$notify.error(res.Msg);
          }
        });
    },
    //设备故障分析-故障类类分布
    async getDeviceFaultType() {
      this.DeviceFaultTypeLoading = true;
      this.$http
        .post("/PB/PB_Project/GetDeviceFaultTypeAnalysis", {
          TimeType: this.searchData.TimeType,
          StartTime: this.searchData.StartTime,
          EndTime: this.searchData.EndTime,
          DeviceTypes: this.searchData.DeviceTypes.join(","),
          Buildings: this.searchData.Buildings.join(","),
        })
        .then((res) => {
          this.DeviceFaultTypeLoading = false;
          if (res.Success) {
            this.DeviceFaultType = res.Data || {};
          } else {
            this.$notify.error(res.Msg);
          }
        });
    },
    //设备故障分析- 寿命期故障分布
    async getDeviceFaultTypeYear() {
      this.DeviceFaultTypeYearLoading = true;
      this.$http
        .post("/PB/PB_Project/GetDeviceFaultTypeYearAnalysis", {
          TimeType: this.searchData.TimeType,
          StartTime: this.searchData.StartTime,
          EndTime: this.searchData.EndTime,
          DeviceTypes: this.searchData.DeviceTypes.join(","),
          Buildings: this.searchData.Buildings.join(","),
        })
        .then((res) => {
          this.DeviceFaultTypeYearLoading = false;
          if (res.Success) {
            this.DeviceFaultTypeYear = res.Data || [];
          } else {
            this.$notify.error(res.Msg);
          }
        });
    },
    //设备寿命分布 楼栋 设备
    getDeviceLifespan() {
      this.DeviceLifespanLoading = true;
      this.$http.post("/PB/PB_Project/GetEquipmentLifespanAnalysis", {}).then((res) => {
        this.DeviceLifespanLoading = false;
        if (res.Success) {
          this.DeviceLifespan = res.Data || {};
        } else {
          this.$notify.error(res.Msg);
        }
      });
    },
    //设备价值分布 楼栋 设备
    getDeviceValue() {
      this.DeviceValueLoading = true;
      this.$http.post("/PB/PB_Project/GetEquipmentValueAnalysis", {}).then((res) => {
        this.DeviceValueLoading = false;
        if (res.Success) {
          this.DeviceValue = res.Data || {};
        } else {
          this.$notify.error(res.Msg);
        }
      });
    },
    //设备报废分布 楼栋 设备
    getDeviceScrapping() {
      this.DeviceScrappingLoading = true;
      this.$http.post("/PB/PB_Project/GetEquipmentScrappingAnalysis", {}).then((res) => {
        this.DeviceScrappingLoading = false;
        if (res.Success) {
          this.DeviceScrapping = res.Data || {};
        } else {
          this.$notify.error(res.Msg);
        }
      });
    },
    //设备区域分布
    getDeviceDistribution() {
      this.DeviceDistributionLoading = true;
      this.$http
        .post("/PB/PB_Project/GetEquipmentDistributionAnalysis", {})
        .then((res) => {
          this.DeviceDistributionLoading = false;
          if (res.Success) {
            this.DeviceDistribution = res.Data || [];
          } else {
            this.$notify.error(res.Msg);
          }
        });
    },
    getInfoList() {
      this.getDeviceDistribution();
      this.getDeviceScrapping();
      this.getDeviceValue();
      this.getDeviceLifespan();
    },
    classTypeChange() {
      if (this.searchData.classType == "bui") {
        this.searchData.Buildings = this.BuildingsList.map((item) => item.Id);
      } else if (this.searchData.classType == "dev") {
        this.searchData.DeviceTypes = this.DeviceTypesList.map((item) => item.Id);
      }
    },
    timeTypeChange() {
      if (this.searchData.TimeType === "Year") {
        if (!this.searchData.StartTimeYear || this.searchData.EndTimeYear) {
          this.searchData.StartTimeYear = moment().format("YYYY");
          this.searchData.EndTimeYear = moment().format("YYYY");
        }
      } else if (this.searchData.TimeType === "YearMonth") {
        this.searchData.searchYear = [
          moment().startOf("year").format("YYYYMM"),
          moment().endOf("year").format("YYYYMM"),
        ];
      }
      this.getDataList();
    },
    DeviceTypesListChange(a) {
      console.log(a);
      if (a.length === 1) {
        this.DeviceTypesList.find((item) => item.Id === a[0]).disabled = true;
      } else {
        this.DeviceTypesList.forEach((item) => {
          item.disabled = false;
        });
      }
      this.debouncedGetDataList();
    },
    BuildingsListChange(a) {
      console.log(a);
      if (a.length === 1) {
        this.BuildingsList.find((item) => item.Id === a[0]).disabled = true;
      } else {
        this.BuildingsList.forEach((item) => {
          item.disabled = false;
        });
      }

      this.debouncedGetDataList();
    },
    //获取楼栋列表
    async getBuildingDataList() {
      this.buildingLoading = true;
      await this.$http
        .post("/PB/PB_Project/GetProjectBuildingDataList", {})
        .then((res) => {
          this.buildingLoading = false;
          if (res.Success) {
            this.BuildingsList = res.Data || [];
            this.BuildingsList.forEach((item) => {
              this.$set(item, "disabled", false);
            });
            this.searchData.Buildings = this.BuildingsList.map((item) => item.Id);
          } else {
            this.$notify.error(res.Msg);
          }
        });
    },
    async getProjectDeviceTypeList() {
      this.deviceTypeLoading = true;
      await this.$http.post("/PB/PB_Project/GetDevcieDictionaryMain", {}).then((res) => {
        this.deviceTypeLoading = false;
        if (res.Success) {
          this.DeviceTypesList = res.Data || [];
          this.DeviceTypesList.forEach((item) => {
            this.$set(item, "disabled", false);
          });
          this.searchData.DeviceTypes = this.DeviceTypesList.map((item) => item.Id);
        } else {
          this.$notify.error(res.Msg);
        }
      });
    },
    getDataList() {
      if (this.searchData.TimeType === "Year") {
        this.searchData.StartTime = this.searchData.StartTimeYear;
        this.searchData.EndTime = this.searchData.EndTimeYear;
      } else if (this.searchData.TimeType === "YearMonth") {
        this.searchData.StartTime = this.searchData.searchYear[0];
        this.searchData.EndTime = this.searchData.searchYear[1];
      }
      this.getDeviceFaultDataList();
    },
    //获取所有需要参数的设备故障相关数据
    getDeviceFaultDataList() {
      this.getDeviceFault();
      this.getDeviceStopPower();
      this.getDeviceStopPowerHourType();
      this.getDeviceStopPowerCountType();
      this.getDeviceFaultYearMonth();
      this.getDeviceFaultYears();
      this.getDeviceFaultType();
      this.getDeviceFaultTypeYear();
    },
  },
  mounted() {},
  async created() {
    // this.searchData.StartTimeYear = moment().format("YYYY");
    // this.searchData.EndTimeYear = moment().format("YYYY");
    // this.searchData.searchYear = [
    //   moment().startOf("year").format("YYYYMM"),
    //   moment().endOf("year").format("YYYYMM"),
    // ];
    // this.loading = true;
    // // await this.getProjectDeviceTypeList();
    // // await this.getBuildingDataList();
    // this.loading = false;

    this.getInfoList();
    this.debouncedGetDataList = this.$tools.debounce(function () {
      this.getDataList();
    }, 500);
  },
  computed: {
    startYearOptions() {
      return {
        disabledDate: (time) => {
          const year = time.getFullYear();
          // 如果结束年份已选择，开始年份需在 [结束年份-10, 结束年份] 范围内
          if (this.searchData.EndTime) {
            const end = parseInt(this.searchData.EndTime);
            return year > end || year < end - 10;
          }
          return false;
        },
      };
    },
    endYearOptions() {
      return {
        disabledDate: (time) => {
          const year = time.getFullYear();
          // 如果开始年份已选择，结束年份需在 [开始年份, 开始年份+10] 范围内
          if (this.searchData.StartTime) {
            const start = parseInt(this.searchData.StartTime);
            return year < start || year > start + 10;
          }
          return false;
        },
      };
    },
  },
  watch: {
    async activeName(nvalue) {
      if (nvalue == "2") {
        this.DeviceFaultLoading = true;
        this.DeviceStopPowerLoading = true;
        this.DeviceStopPowerHourTypeLoading = true;
        this.DeviceStopPowerCountTypeLoading = true;
        this.DeviceFaultYearMonthLoading = true;
        this.DeviceFaultTypeLoading = true;
        this.debouncedGetDataList();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.label {
  font-size: 14px;
  font-weight: bold;
  margin-right: 20px;
  margin-left: 10px;
  display: inline-block;
  width: 100px;
  text-align: right;
}
.search-item {
  display: flex;
  align-items: center;
  margin: 10px 0;
  .el-checkbox-group {
    flex: 1;
  }
}
.yearSelect {
  display: flex;
  align-items: center;
  justify-content: center;

  .separator {
    font-size: 12px;
    margin: 0 10px;
  }
}
.table-card {
  flex: 1;

  text-align: right;
  border-bottom: 1px solid #e4e7ed;
  display: flex;
  align-items: center;
  justify-content: right;
  font-size: 14px;
  font-weight: bold;
}
.Table-List {
  display: flex;

  gap: 15px;
  padding: 10px 0;
}
::v-deep .divider {
  height: auto;
}
.class-table {
  width: 100%;
  display: flex;
}
.class-tableItem {
  flex: 1;
  .class-tableItem-title {
    font-size: 14px;
    font-weight: bold;
    height: 40px;
    border-bottom: 1px solid #e4e7ed;
    display: flex;
    align-items: center;
    justify-content: right;
  }
  .class-tableItem-content {
    border-bottom: 1px solid #e4e7ed;
    display: flex;
    align-items: center;
    justify-content: right;
    height: 40px;
    font-size: 12px;
  }
}
::v-deep .el-date-editor {
  .el-input__inner {
    text-align: center;
  }
}
</style>
